import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import NavBarItem from './navBarItem/NavBarItem';
import styles from './navBar.scss';

class NavBar extends PureComponent {
  render() {
    const { className, entries, subEntries, ...other } = this.props;
    return (
      <div
        className={className ? `${styles.navBar} ${className}` : styles.navBar}
      >
        {entries.map((entry, index) => {
          return (
            <NavBarItem
              entry={entry}
              subEntries={subEntries[entry.title]}
              key={index}
              {...other}
            />
          );
        })}
      </div>
    );
  }
}

NavBar.propTypes = {
  className: PropTypes.string,
  entries: PropTypes.array,
  subEntries: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default NavBar;
